import { render, staticRenderFns } from "./CarrierGeis.vue?vue&type=template&id=bed5f8fa&scoped=true&"
import script from "./CarrierGeis.vue?vue&type=script&lang=js&"
export * from "./CarrierGeis.vue?vue&type=script&lang=js&"
import style0 from "./CarrierGeis.vue?vue&type=style&index=0&id=bed5f8fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed5f8fa",
  null
  
)

export default component.exports